// Core
import React from 'react';
import { Box, Flex, Text, Divider, Grid, Image, useColorMode } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';

// Components
import Card from 'components/Card/Card';

const FeaturedOn = ({ image }) => {
    const cardTopLine = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
    const cardTopLineHover = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #FFF  56.18%, #38A9E1 68.16%, #38A9E1 82.69%, rgba(56, 169, 225, 0.00) 100%)';

    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    return (
        <Card className="animation-featured-on" padding="0px" mb={{base: '8px', md: '16px'}} overflow="hidden" borderWidth="0">
            { isDark && <Box bg="#099BFF" position="absolute" filter="blur(28px)" h="21px" w="100%" mt="-12px" /> }

            <Image src={image} all="featured" maxW={{base: '35%', sm: '50%', md: '70%'}} m={{base: '4px auto', md: '15px auto'}} zIndex="2" />

            { isDark ? 
                <Lines className="abstract-lines" style={{ zIndex: 1, transform: 'scale(0.8)', left: '-100%', marginTop: '-70%'}} />
                :
                <LinesWhite className="abstract-lines" style={{ zIndex: 1, transform: 'scale(0.8)', left: '-100%', marginTop: '-70%', opacity: 0.3}} />
            }
            { isDark && <Box position="absolute" w="100%" bottom="0px">
                <Box bg={cardTopLine} transform="rotate(180deg)" zIndex="1" h="2.5px" bottom="0" position="absolute" w="100%" />
                <Box bg={cardTopLineHover} transform="rotate(180deg)" zIndex="2" opacity="0" h="2px" bottom="0" position="absolute" w="100%" className="animation-featured-on-line" />
                <Box bg="#099BFF" filter="blur(38px)" h="31px" /> 
            </Box> }
        </Card>
    );
};


export default FeaturedOn;